// Shared utils for PlatformLanding sub-components.
import { Sparkles, Layers, Shield, Package, Truck, Wand2,
         CalendarDays, Heart, Bot, Video, Workflow, CreditCard,
         BarChart3, GraduationCap } from "lucide-react";

// Keyed LOWERCASE, like every currency this product stores. The pricing grids on the
// marketing site are read straight off the plan documents, whose keys were lowercased
// with everything else (migration `_lowercase_money_grid_keys`).
export const CURRENCY_SYMBOLS = { cad: "$", usd: "$" };

// THE currencies a practice may sign up in — the shared list (lib/currencies.js), so the
// marketing page cannot advertise a price in a currency signup would refuse.
export { OPERATING_CURRENCIES } from "../../lib/currencies";

export const formatPrice = (amount, currency) => {
  const symbol = CURRENCY_SYMBOLS[String(currency || "").toLowerCase()] || "$";
  if (!amount) return `${symbol}0`;
  return `${symbol}${Math.round(amount).toLocaleString()}`;
};

export const BOOSTER_ICONS = { sparkles: Sparkles, layers: Layers, shield: Shield };
export const SKU_ICONS = { install: Package, data_porting: Truck };
export const FALLBACK_BOOSTER_ICON = Wand2;

// The icon of each of the eight modules, keyed by module id. Icons are chrome, not site
// copy (contract §2.7): the labels are rendered by `Hero.jsx` (module bar) and
// `EcosystemFeatures.jsx` (feature cards) through literal `text("ecosystem.<id>")` calls,
// so the registry drift test can see every key.
export const MODULE_ICONS = {
  practice: CalendarDays,
  journeys: Heart,
  ai: Bot,
  telehealth: Video,
  automations: Workflow,
  payments: CreditCard,
  insights: BarChart3,
  courses: GraduationCap,
};
